var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ width: '100%', height: '100%' })},[_c('PwaVideoDetailShare',{attrs:{"feed-page":_vm.isShareDetail ? _vm.FeedPageEnum.VideoDetailShare : _vm.FeedPageEnum.VideoDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }